<!-- 首页 -->
<template>
  <div :class="['teacherDetail', { inApp: $root.$data.isApp||this.$root.miniprogram }]">
    <common-title titleName="教师介绍" :bcColor="'#fff'" :zIndex="1000"></common-title>
    <div class="teachercontent" v-show="teacher.publicName">
      <div class="up">
        <div class="up_lt">
          <img :src="teacher.topicWebHead" alt="" />
        </div>
        <div class="up_rt">
          <h2>{{ teacher.publicName }}</h2>
          <p>{{ teacher.teachMainModule }}</p>
        </div>
      </div>
      <div class="middle" v-if="teacher.teachFeature">
        <div class="spe"><em></em><span>授课特色：</span></div>
        <p>
          {{ teacher.teachFeature }}
        </p>
      </div>
      <div class="middle" v-if="teacher.teacherBrief">
        <div class="spe"><em></em><span>教师简介：</span></div>
        <p>
          {{ teacher.teacherBrief }}
        </p>
      </div>
      <div class="video" v-show="teacher.auditionVideo&&$route.query.source !== 'branch'">
        <div class="spe"><em></em><span>试听视频课</span></div>
        <div class="videobox">
          <div id="player"></div>
        </div>
      </div>
    </div>
    <EmptyData v-show="!teacher.publicName" emptyName="noEvaluation" />
  </div>
</template>
<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import HotCourseCard from '@/components/hotCourseCard/hotCourseCard.vue';
import EmptyData from '@/components/emptyData/emptyData.vue';
import { reqTeacherInfo, reqTeacherProduct } from '@/api/teacherInfo';
import { reqProducts } from '@/api/home';
import { RECORD_SITE_ID } from '@/utils/common';
import loadJS from 'load-js';
export default {
  data() {
    return {
      productIds: [], //教师关联产品id
      courseList: [], //课程
      teacher: [], //师资介绍详情
      player: null,
    };
  },
  components: {
    CommonTitle,
    HotCourseCard,
    EmptyData,
  },
  computed: {},

  created() {},
  mounted() {
    this.getTeacherInfo();
  },
  destroyed() {
    this.player && this.player.destroy();
  },
  methods: {
    //获取教师详情
    async getTeacherInfo() {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      let teacherId = this.$route.query.teacherId * 1;
      const res = await reqTeacherInfo(teacherId);
      if (res.code === 0 && res.data) {
        this.teacher = res.data;
        this.initData();
      }
      this.$toast.clear();
    },
    //试听课程
    initData() {
      document.getElementById('player').innerHTML = '';
      // CC的录播视频
      loadJS([
        {
          async: false,
          url: `https://p.bokecc.com/player?siteid=${RECORD_SITE_ID}&newversion=true`,
        },
      ]).then(() => {
        this.setPlayerCallBack();
      });
    },
    setPlayerCallBack() {
      if (window.createCCH5Player) {
        this.createPlayer();
      } else {
        window.onCCH5PlayerLoaded = this.onCCH5PlayerLoaded;
      }
      window.onCCH5PlayerLoaded = this.onCCH5PlayerLoaded;
    },
    onCCH5PlayerLoaded() {
      window.ccH5PlayerJsLoaded = true;
      this.createPlayer();
    },
    createPlayer() {
      if (this.teacher.auditionVideo && this.teacher.auditionVideoCC) {
        const { auditionVideo, auditionVideoCC } = this.teacher;
        this.player = window.createCCH5Player({
          vid: auditionVideoCC,
          siteid: RECORD_SITE_ID,
          autoStart: true,
          width: '100%',
          height: '100%',
          parentNode: document.getElementById('player'),
          vc: auditionVideo * 1, //授权码 int类型
        });
      } else {
       // this.$toast('视频地址出错,请稍后重试～');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .common-foot {
  position: fixed;
}
.teacherDetail {
  width: 100%;
  height: 100vh;
  padding-top: 100px;
  padding-bottom: 100px;
  background: #fff;
  &.inApp {
    padding-top: 0;
    padding-bottom: 0;
  }
}
.teachercontent {
  padding: 40px 40px 40px;
  .spe {
    display: flex;
    align-items: center;
    em {
      display: block;
      width: 8px;
      height: 24px;
      background: #ff7f41;
      border-radius: 4px;
    }
    span {
      display: block;
      margin-left: 12px;
      color: #323232;
      font-weight: 500;
      font-size: 36px;
    }
  }
  .up {
    display: flex;
    justify-content: space-between;
    margin-bottom: 70px;
    .up_lt {
      position: relative;
      width: 302px;
      height: 318px;
      background: linear-gradient(180deg, #fef9f4 0%, #fcc495 100%);
      border-radius: 32px;
      img {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1;
        display: block;
        width: 220px;
        height: 326px;
        margin: 0 auto;
      }
    }
    .up_rt {
      width: 344px;
      h2 {
        margin-bottom: 8px;
        color: #333;
        font-weight: 500;
        font-size: 48px;
      }
      p {
        display: -webkit-box;
        overflow: hidden;
        color: #666;
        font-weight: 400;
        font-size: 28px;
        line-height: 48px;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }
  }
  .middle {
    p {
      margin-top: 14px;
      margin-bottom: 40px;
      color: #666;
      font-weight: 400;
      font-size: 28px;
      line-height: 48px;
    }
  }
  .video {
    .videobox {
      height: 376px;
      margin-top: 20px;
      margin-bottom: 40px;
      border-radius: 16px;
      #player {
        height: 100%;
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }
}
.teacher {
  .spe {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 0 40px;
    em {
      display: block;
      width: 8px;
      height: 24px;
      background: #ff7f41;
      border-radius: 4px;
    }
    span {
      display: block;
      margin-left: 12px;
      color: #323232;
      font-weight: 500;
      font-size: 36px;
    }
  }
}
.courseList::-webkit-scrollbar {
  display: none;
}
.courseList {
  box-sizing: border-box;
  width: 100%;
  min-height: 98px;
}
.courseList > li {
  position: relative;
  width: 679px;
  margin: 0 auto;
  margin-bottom: 18px;
  background: $bgWhite;
  border-radius: 7px;
  .liveImg {
    position: absolute;
    top: 0;
    right: 0;
    width: 140px;
    height: 50px;
    border-radius: 0 16px 0 32px;
  }
}
</style>